// type checks

export function isI18nData(obj) {
  return obj && obj.type === 'i18n';
}